














































import { defineComponent, reactive, SetupContext, toRefs, onMounted } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface StreamingUrl {
  id: number
  grade_id: number
  url: string
  streaming_date: string
}

export interface Data {
  streaming_urls: StreamingUrl[]
  today: string
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      streaming_urls: [],
      today: Common.formatDate(new Date(), "Y年M月D日"),
      errors: [],
    });

    const entryClick = async () => {

      if(!window.confirm("URLを登録します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/streaming_url_edit/update/`, {streaming_urls: state.streaming_urls}).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      
      await http.get(`/api/streaming_url_edit`).then(response => {
        state.streaming_urls = response.data.streaming_urls;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      entryClick,
    };
  },
})
